import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import styles from './AiCreditsIndicator.module.scss';

export type AiCredits = {
  // Display credits left in the current billing period and the period cap
  // (1000 credits = 1 EUR). Null/undefined credits → the line is hidden.
  remaining: number;
  total: number;
};

type Props = {
  credits?: AiCredits | null;
};

// Reusable credits counter (Figma node 31921:279528): a sparkle icon + the
// "{remaining} / {total} company credits remaining" line. Shared by the AI
// field-assist surfaces and the chat composer. Renders null when there is no
// credits data so it can be dropped in anywhere without a guard at the callsite.
export default function AiCreditsIndicator({ credits }: Props) {
  const { t } = useTranslation();

  if (!credits) return null;

  return (
    <div className={styles.root}>
      <MaterialIcon
        icon="auto_awesome"
        symbolsOutlined
        size="md-16"
        className={styles.icon}
      />
      <Typography variant="label" block>
        {t('ai-credits-remaining', {
          remaining: credits.remaining,
          total: credits.total,
        })}
      </Typography>
    </div>
  );
}
